import { Component, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { catchError, debounceTime, distinctUntilChanged, filter, finalize, of, Subscription, switchMap } from 'rxjs';
import { PerformanceParameterService } from 'src/app/modules/services/performanceParameter/performance-parameter.service';
import { LoadingService } from '../../loading/loading.service';
import { AlertComponent } from '../../alert/alert.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '../../modal/modal.component';
import { ModalEditComponent } from './modal-edit/modal-edit.component';
import { HighwaysService } from 'src/app/modules/services/highways/highways.service';
import { ModalHistoricComponent } from 'src/app/modules/shared/modals/modal-historic/modal-historic.component';
import { ModalController } from '@ionic/angular';
import { ImportModalComponent } from 'src/app/modules/shared/modals/import-modal/import-modal.component';
import { ImportValidationComponent } from 'src/app/modules/shared/modals/import-validation/import-validation.component';

@Component({
  selector: 'app-parametro-de-desempenho',
  templateUrl: './parametro-de-desempenho.component.html',
  styleUrls: ['./parametro-de-desempenho.component.scss']
})
export class ParametroDeDesempenhoComponent implements OnInit {
  @Input() cnpj:any;
  selectedOptionPatologia: any;
  filteredOptionsPatologias: any[] = [];
  searchControlPatologia = new FormControl();
  selectedOptionTipoDeReparo: any;
  filteredOptionsTipoDeReparo: any[] = [];
  searchControlTipoDeReparo = new FormControl();
  prazoDeAtendimentoControl = new FormControl();
  medidaPrazoDeAtendimentoControl = new FormControl();
  @Output() dataSource = new MatTableDataSource<any>([])
  @Input() buttonInclusaoDisabled: boolean = false;
  @Input() buttonExclusaoDisabled: boolean = false;
  @Input() buttonEdicaoDisabled: boolean = false;
  screenWidth: number = 0;
  screenHeight: number = 0;
  repairTypes: any[] = []
  pathologies: any[] = []
  @Input() pageSize: number = 10;

  @Input() pageIndex: number = 0;
  @Input() totalPages: number = 1;
  @Input() totalElements: number = 1;

  @Input() highWay: any
  @Input() contractId: any
  @Input() isEditMode: boolean = false;
  params = {

  }
  subsctiptions: Subscription[] = [];
  displayedColumns: string[] = [
    'tipoDefeito',
    'prazo',
    'tipoDeReparo',
    'actions',
  ];
  sortState: any = { sortProperty: 'criadoEm', sortDirection: 'desc' };

  constructor(
    private performanceParameterService: PerformanceParameterService,
    private highwayService: HighwaysService,
    private _snackBar: MatSnackBar,
    private loadingService: LoadingService,
    public _dialog: MatDialog,
    private modalCtrl: ModalController,
  ) { }

  ngOnInit(): void {

    this.searchControlPatologia.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(), filter(value => value && value.trim().length > 0),
      switchMap(value =>
        this.performanceParameterService.listPatology(this.pageIndex, this.pageSize,
          'name',
          'asc',
          value
        )
          .pipe(
            catchError(() => of([]))
          ))
    ).subscribe((results: any) => {
      this.filteredOptionsPatologias = results.content
    })
    this.searchControlTipoDeReparo.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(), filter(value => value && value.trim().length > 0),
      switchMap(value =>
        this.performanceParameterService.listTypesofRepairs(this.pageIndex, this.pageSize,
          'name',
          'asc',
          value
        )
          .pipe(
            catchError(() => of([]))
          ))
    ).subscribe((results: any) => {
      this.filteredOptionsTipoDeReparo = results.content
    })

    this.medidaPrazoDeAtendimentoControl.valueChanges.subscribe((value) => {
      if (value === 'Imediato') {
        this.prazoDeAtendimentoControl.setValue('');
        this.prazoDeAtendimentoControl.disable();
      } else {

        this.prazoDeAtendimentoControl.enable();
      }
    });

    this.onGetperformanceParameter()
    this.onGetAllData()


    this.getScreenDimensions();
    window.addEventListener('resize', this.getScreenDimensions.bind(this));

  }
  getScreenDimensions() {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
  }
  onFocusPatologia() {
    this.filteredOptionsPatologias = this.pathologies;
  }
  formatPrazo(serviceDeadline: string): string {
    if (!serviceDeadline) {
      return '';
    }
  
    // Exemplo: "1 Anos", "2 Meses", "1 Dias"
    const [quantidade, unidade] = serviceDeadline.split(' ');
    
    const quantidadeNum = parseInt(quantidade, 10);
  
    let unidadeSingular;
    if (unidade.toLowerCase().includes('ano')) {
      unidadeSingular = 'Ano';
    } else if (unidade.toLowerCase().includes('mes')) {
      unidadeSingular = 'Mês';
    } else if (unidade.toLowerCase().includes('dia')) {
      unidadeSingular = 'Dia';
    }
     else if (unidade.toLowerCase().includes('hora')) {
      unidadeSingular = 'Hora';
    }
  
    return quantidadeNum > 1 ? `${quantidadeNum} ${unidade.includes('Mes') ? 'Meses': unidade}` : `${quantidadeNum} ${unidadeSingular}`;
  }

  onGetAllData() {
    this.performanceParameterService.listPatology(this.pageIndex, this.pageSize,
      'name',
      'asc',
    ).pipe(
      catchError(() => of([]))
    )
      .subscribe((results: any) => {
        this.pathologies = results.content
      })

    this.performanceParameterService.listTypesofRepairs(this.pageIndex, this.pageSize,
      'name',
      'asc',

    )
      .pipe(
        catchError(() => of([]))
      ).subscribe((results: any) => {
        this.repairTypes = results.content
      })
  }
  onFocusTipoDeReparo() {
    this.filteredOptionsTipoDeReparo = this.repairTypes;
  }
  onGetperformanceParameter(
    pageIndex: number = 0,
  ) {
    this.loadingService.showLoading();
    this.performanceParameterService.listPerfomanceParameter(
      pageIndex,
      this.pageSize,
      this.contractId,
      this.sortState.sortDirection,
      this.sortState.sortProperty,
    ).pipe(
      finalize(() => {
        this.loadingService.hideLoading();
      })
    ).subscribe({
      next: (res: any) => {
        const { content, pageSize, totalPages, totalElements, pageNumber } =
          res;
        this.dataSource.data = content
        this.pageSize = pageSize;
        this.totalPages = totalPages;
        this.totalElements = totalElements;
        this.pageIndex = pageNumber;
      }, error: (err: any) => {
        if (err.error.message === 'Nenhum parâmetro de desempenho encontrado.') {
          this.dataSource.data = []
        } else {
          this.openSnackBar(err.error.message, 'error');
        }

      }
    })

  };



  openSnackBar(description: string, type: string) {
    let classSnack = '';
    switch (type) {
      case 'sucess':
        classSnack = 'snacbar-sucess';
        break;
      case 'warning':
        classSnack = 'snacbar-warning';
        break;
      case 'error':
        classSnack = 'snacbar-error';
        break;
    }

    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description: description, type: type },
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  onOptionSelectedPatologia(event: any) {
    this.selectedOptionPatologia = event.option.value;
    this.searchControlPatologia.setValue(this.selectedOptionPatologia.name, { emitEvent: false });

    this.filteredOptionsPatologias = [];
  }
  onOptionSelectedTipoDeReparo(event: any) {
    this.selectedOptionTipoDeReparo = event.option.value;
    this.searchControlTipoDeReparo.setValue(this.selectedOptionTipoDeReparo.name, { emitEvent: false });

    this.filteredOptionsTipoDeReparo = [];
  }

  onSortChange(sortProperty: 'pathology' | 'serviceDeadline' | 'repairType'): void {

    if (this.sortState.sortProperty === sortProperty) {
      this.sortState.sortDirection =
        this.sortState.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {

      this.sortState.sortDirection = 'asc';
    }
    this.sortState.sortProperty = sortProperty;

    this.onGetperformanceParameter()

  }

  pageChangeEvent(event: PageEvent) {
    if (this.pageIndex !== event.pageIndex) {
      this.onGetperformanceParameter(event.pageIndex)
    }
  }

  openDeleteDialog(id: string): void {
    const modalTitle: string = 'Excluir';
    const modalContent: string =
      'Você tem certeza que deseja excluir este Parametro?';

    const dialogRef = this._dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onDeleteModalConfirm.bind(this),
        modalTitle: modalTitle,
        modalContent: modalContent,
        id: id,
      },
    });
  }

  onDeleteModalConfirm(id: any): void {
    this.loadingService.showLoading();

    this.subsctiptions.push(
      this.performanceParameterService.deletePerfomanceParameter(this.contractId, id).pipe(
        finalize(() => {
          this.loadingService.hideLoading();
        })
      ).subscribe({
        next: (res: any) => {
          this.openSnackBar("Parâmetro de desempenho excluído com sucesso.", 'sucess');

          this.onGetperformanceParameter()
        },

        error: (err: any) => {
          this.openSnackBar(err.error.message, 'error');
        }
      })

    );
  }

  editParameter(parameter: any) {

    let data = {
      isEditMode: true,
      parameter: parameter
    }
    const dialog = this._dialog.open(ModalEditComponent, {
      panelClass: ['filter-panel'],
      data: data
    });

    dialog.afterClosed().subscribe({

      next: (res: any) => {
        if (res) {
          this.loadingService.showLoading()
          this.performanceParameterService.editPerfomanceParameter(this.contractId, res, parameter.id).pipe(
            finalize(() => {
              this.loadingService.hideLoading();
            })
          ).subscribe({
            next: (res: any) => {
              this.openSnackBar("Parâmetro de desempenho Editado com sucesso.", 'sucess');

              this.onGetperformanceParameter()
            },

            error: (err: any) => {
              this.openSnackBar(err.error.message, 'error');
            }
          })
        }
      }
    })
  }
  openModalDialogCreate() {

    let data = {
      isEditMode: false
    }
    const dialog = this._dialog.open(ModalEditComponent, {
      panelClass: ['filter-panel'],
      data: data
    });

    dialog.afterClosed().subscribe({

      next: (res: any) => {
        if (res) {
          this.loadingService.showLoading()
          this.performanceParameterService.createPerfomanceParameter(this.contractId, res).pipe(
            finalize(() => {
              this.loadingService.hideLoading();
            })
          ).subscribe({
            next: (res: any) => {
              this.openSnackBar("Parâmetro de desempenho cadastrado com sucesso.", 'sucess')
              this.onGetperformanceParameter()

              this.searchControlPatologia.setValue('', { emitEvent: false })
              this.searchControlTipoDeReparo.setValue('', { emitEvent: false })
              this.prazoDeAtendimentoControl.setValue('', { emitEvent: false })
              this.medidaPrazoDeAtendimentoControl.setValue('', { emitEvent: false })
            }, error: (err: any) => {
              this.openSnackBar(err.error.message, 'error');
            }
          })
        }
      }
    })
  }

  async  openDialogHistoricoParametro(contractId: string, segmentId: string){
     
        const data = {
          type: 'parametro',
          id: contractId,
          segmentId: segmentId,
      
          fieldMappings: {
            id: 'Id',
            pathology: 'Patologia',
            serviceDeadline: 'Prazo',
            repairType: 'Tipo de Reparo',
            totalExtensionKm: 'Extensão'
          }
        }
        const modal = await this.modalCtrl.create({
          component: ModalHistoricComponent,
          componentProps: {
            data: data,
            fieldMappings: data.fieldMappings,
          },
        });
    
        modal.present();
}
  
      openImportModal() {
        const data = {
              isFrenteConservacao: true,
        };
        const dialogRef = this._dialog.open(ImportModalComponent, {
          panelClass: ['anotation-panel'],
          data,
        });
      
    
        dialogRef.afterClosed().subscribe({
          next: (file: any) => {
            if (file) {
              // this.openModalImportValidation(mockDataValid, file);
              this.loadingService.showLoading();
              this.performanceParameterService
                .validatePerfomanceParameter(this.contractId, file)
                .pipe(
                  finalize(() => {
                    this.loadingService.hideLoading();
                  })
                )
                .subscribe({
                  next: (res: any) => {
                    this.openModalImportValidation(res, file);
                  },
                  error: (err: any) => {
                    this.openSnackBar(err.error.message, 'error');
                  },
                });
            }
          },
        });
      }
      openModalImportValidation(resp:any, file: any){
        
        const data = {
          resp: resp,
          file:file,
           from:'parametro'
        };
    
        const dialogTableValidation = this._dialog.open(ImportValidationComponent, {
    
          width: '800px',
          height: '850px',
          data,
        });
    
        dialogTableValidation.afterClosed().subscribe({
          next: (res: any) => {
            if (res && !res.retry) {
              this.loadingService.showLoading();
              this.performanceParameterService
                .importPerfomanceParameter(this.contractId, resp, file, this.cnpj)
                .pipe(
                  finalize(() => {
                    this.loadingService.hideLoading();
                  })
                )
                .subscribe({
                  next: (res: any) => {
                    this.onGetperformanceParameter();
                    this.openSnackBar('Importação finalizada com sucesso.', 'sucess');
                  },
                  error: (err: any) => {
                    this.openSnackBar(err.error.message, 'error');
                  },
                });
            }else{
              if(res.retry){
                this.openImportModal();
              }
            }
          },
        });
      }
}
